import { CurrencyPipe, NgClass } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { GoalModel } from '@bp-core/src/lib/proto/common-message.pb';
import { BpCoreModule } from '../../../../../../bp-core/src/lib/bp-core.module';
import { GoalInfoCallback } from '../../models/goal-info-callback';
import { GoalInfoType } from '../../models/goal-info-type.enum';
/**
 * Componente que muestra la información de una meta en una tarjeta.
 *
 */
@Component({
  selector: 'app-goal-info-card',
  templateUrl: './goal-info-card.component.html',
  styleUrls: ['./goal-info-card.component.scss'],
  standalone: true,
  imports: [
    BpCoreModule,
    MatRippleModule,
    NgClass,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    CurrencyPipe,
  ],
})
export class GoalInfoCardComponent implements OnInit {
  @Input() goal: GoalModel | undefined;
  @Input() goalInfoType: GoalInfoType = GoalInfoType.IS_FROM;
  @Input() hasTooltip = true;
  @Input() hasStarred = false;
  @Input() isDisabled = false;
  @Input() callback?: GoalInfoCallback;
  goalInfoTypeEnum = GoalInfoType;
  constructor() {}

  ngOnInit(): void {}
}
